//export default class Mission {
//   constructor() {
//     this.$sections = document.querySelectorAll('section.mission');
//   }
//}
//
//new Mission();

document.querySelectorAll(".card").forEach((card) => {
  card.addEventListener("click", function () {
    card.classList.toggle("card-clicked");
    card.querySelector(".front").classList.toggle("hidden");
    card.querySelector(".back").classList.toggle("hidden");
  });
  card.addEventListener("mouseenter", function () {
    card.classList.toggle("card-clicked");
    card.querySelector(".front").classList.toggle("hidden");
    card.querySelector(".back").classList.toggle("hidden");
  });
  card.addEventListener("mouseleave", function () {
    card.classList.toggle("card-clicked");
    card.querySelector(".front").classList.toggle("hidden");
    card.querySelector(".back").classList.toggle("hidden");
  });
});
